/**
 * 销售 H5 / 小程序 web-view 壳判断。
 * 与 Login.vue 原 isH5Login 规则一致：admin=1 走 PC，h5=1 或移动 UA 走 H5。
 */
function isH5Shell (query, userAgent) {
  const q = query || {}
  const ua = userAgent || ''
  if (q.admin === '1') {
    return false
  }
  if (q.h5 === '1') {
    return true
  }
  return /Android|iPhone|iPad|iPod|Mobile/i.test(ua)
}

function shouldCheckTimeZoneMismatch (query, userAgent) {
  return !isH5Shell(query, userAgent)
}

module.exports = {
  isH5Shell,
  shouldCheckTimeZoneMismatch
}
